import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { BackboneViewProps } from '../../../../types';
import app from '../../../../app';
import { isUserReadOnly } from '../../../../utils';
import ConversionMappingManager from '../../models/ConversionMappingManager';
import { fetchBusyRecords } from '../../../busyRecords';
import StandardParameterComponent from './components/StandardParameterComponent';

const template = require('./index.pug');

export default Backbone.View.extend({
  async initialize(options: BackboneViewProps) {
    this.tenant = options.tenant;
    this.user = app.session.get('user');
    this.email = this.user.email;
    this.isReadOnly = isUserReadOnly(this.user);

    if (this.isReadOnly) {
      Backbone.history.navigate('error/403', true);
      return this;
    }

    this.conversionMappingDataManager = new ConversionMappingManager(
      this.tenant,
      this.email,
      this.isReadOnly,
      this.user.superKudu
    );

    const [busyRecords] = await Promise.all([
      fetchBusyRecords(this.tenant, 'conversions'),
      this.conversionMappingDataManager.init(),
    ]);

    // Every step writes the blob (save, remove, publish), and model-metadata
    // refuses those while the new editor has a record in progress. The
    // overview shows the banner and stays readable (RGI-2618).
    if (busyRecords.length) {
      Backbone.history.navigate(
        `org/${this.tenant}/mapping/conversion_mapping/overview`,
        true
      );
      return this;
    }

    // Not yet ready to be here
    if (
      !this.conversionMappingDataManager.isFinished &&
      this.conversionMappingDataManager.step === 0
    ) {
      Backbone.history.navigate(
        `org/${this.tenant}/mapping/conversion_mapping`,
        true
      );
    }

    this.render();
    this.renderConnectorsOverviewReactComponent();
  },

  renderConnectorsOverviewReactComponent() {
    ReactDOM.render(
      <StandardParameterComponent
        conversionMappingDataManager={this.conversionMappingDataManager}
      />,
      $('#StandardParameterComponentContainer')[0]
    );
  },

  render() {
    const html = template({});
    this.$el.html(html);

    return this;
  },
});
